export default function tab() {
  const tabMenus = document.querySelectorAll('.p-media__category__button');
  
  // イベント付加
  tabMenus.forEach((tabMenu) => {
    tabMenu.addEventListener('click', tabSwitch);
  })
  
  // イベントの処理
  function tabSwitch(e) {
  
    // クリックされた要素のデータ属性を取得
    const tabTargetData = e.currentTarget.dataset.tab;
    const tabList = e.currentTarget.closest('.p-media__category__list');
    const tabItems = tabList.querySelectorAll('.p-media__category__button');
    const tabPanelItems = document.querySelectorAll('.p-media__contents__panel');
  
    tabItems.forEach((tabItem) => {
      tabItem.classList.remove('is-active');
    })    
    tabPanelItems.forEach((tabPanelItem) => {
      tabPanelItem.classList.remove('is-show');
    })
  
    // クリックされたmenu要素にis-activeクラスを付加\
    tabPanelItems.forEach((tabPanelItem) => {
      if (tabPanelItem.dataset.panel ===  tabTargetData) {
        tabPanelItem.classList.add('is-show');
      }
    })
  }
}
